import React from 'react';
import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './costAndFeesModule.styles';

export const parseLeaseTerms = (termsString: string): Array<string> => {
  const numericPattern = /(\d+)/g;
  const numbers = termsString.match(numericPattern);

  if (numbers && numbers.length > 1) {
    return numbers.map((n) => `${n} months`);
  }

  return [termsString];
};

export const LeaseTermsInline = () => {
  const leaseTerms = useSelector(
    (state: RootReduxState) => state.currentListingDetails?.currentListing?.details?.leaseTerms,
  );

  if (!leaseTerms) return null;

  const terms = parseLeaseTerms(leaseTerms);

  return (
    <div>
      <h3 className={styles.sectionHeading}>Lease terms available</h3>
      <div className={styles.leaseTermsContainer}>
        {terms.map((term) => (
          <span key={term} className={styles.leaseTermPill}>
            {term}
          </span>
        ))}
      </div>
    </div>
  );
};
